module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-products/event-products.component.scss
// module id = ./src/app/routes/event/event-products/event-products.component.scss
// module chunks = 9